import { useState } from "react";
import { Link } from "react-router-dom";
import { COURSES, STAGE_COLORS } from "./trainingData";

function DetailContent({ co }) {
  return (
    <>
      <div className="flex items-center gap-3 mb-5">
        <span
          className="font-mono text-[11px] text-[#a3e635]"
          style={{ letterSpacing: "0.14em" }}
        >
          LEVEL {co.lvl} · {co.stage}
        </span>
        <span className="flex-1 h-px bg-[#27272a]" />
      </div>
      <h3
        className="text-[24px] sm:text-[32px] font-bold mb-3.5 leading-tight"
        style={{ letterSpacing: "-0.025em" }}
      >
        {co.title}
      </h3>
      <p className="text-[16px] leading-[1.65] text-[#a1a1aa] mb-7">
        {co.desc}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-[#27272a] border border-[#27272a] rounded-[10px] overflow-hidden mb-7">
        {[
          { label: "WEEKS", value: co.weeks },
          { label: "MODULES", value: co.mods },
          { label: "LABS", value: co.labs },
          { label: "LEVEL", value: co.difficulty },
        ].map((item) => (
          <div key={item.label} className="bg-black p-4">
            <div
              className="font-mono text-[10px] text-[#71717a]"
              style={{ letterSpacing: "0.1em" }}
            >
              {item.label}
            </div>
            <div
              className={
                item.label === "LEVEL"
                  ? "text-[13px] font-semibold mt-2"
                  : "text-[19px] font-bold mt-[5px]"
              }
            >
              {item.value}
            </div>
          </div>
        ))}
      </div>
      <div
        className="font-mono text-[11px] text-[#71717a] mb-3.5"
        style={{ letterSpacing: "0.14em" }}
      >
        WHAT YOU LEARN
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-2.5 mb-7">
        {co.modules.map((m, i) => (
          <div
            key={i}
            className="flex gap-2.5 text-[14px] text-[#d4d4d8] leading-snug"
          >
            <span className="text-[#a3e635]">/</span>
            {m}
          </div>
        ))}
      </div>
      <div
        className="font-mono text-[11px] text-[#71717a] mb-3"
        style={{ letterSpacing: "0.14em" }}
      >
        TOOLS
      </div>
      <div className="flex flex-wrap gap-2 mb-7">
        {co.tools.map((t, i) => (
          <span
            key={i}
            className="border border-[#27272a] rounded-[5px] px-2.5 py-[5px] font-mono text-[11px] text-[#a1a1aa]"
          >
            {t}
          </span>
        ))}
      </div>
      <div className="border-t border-[#27272a] pt-[22px] grid gap-4">
        <div>
          <div
            className="font-mono text-[11px] text-[#71717a] mb-[7px]"
            style={{ letterSpacing: "0.14em" }}
          >
            CERTIFICATION MAPPED
          </div>
          <div className="text-[15px] text-white font-medium">
            {co.cert}
          </div>
        </div>
        <div>
          <div
            className="font-mono text-[11px] text-[#71717a] mb-[7px]"
            style={{ letterSpacing: "0.14em" }}
          >
            YOU FINISH ABLE TO
          </div>
          <div className="text-[15px] text-[#d4d4d8] leading-relaxed">
            {co.outcome}
          </div>
        </div>
        <div className="flex items-baseline gap-2.5">
          <span
            className="font-mono text-[11px] text-[#71717a]"
            style={{ letterSpacing: "0.14em" }}
          >
            THIS LEVEL
          </span>
          <span className="font-mono text-[15px] text-[#52525b] line-through">
            {co.was}
          </span>
          <span className="text-[18px] sm:text-[22px] font-bold">{co.price}</span>
        </div>
        <Link
          to={`/training/${co.slug}`}
          className="block border border-[#a3e635] text-[#a3e635] rounded-lg px-5 py-3 font-semibold text-[14px] text-center hover:bg-[#a3e635] hover:text-black transition-colors mt-4"
        >
          View full level page →
        </Link>
      </div>
    </>
  );
}

export default function RoadmapSection() {
  const [active, setActive] = useState(0);
  const current = COURSES[active] || COURSES[0];

  return (
    <section id="roadmap" className="max-w-[1200px] mx-auto px-4 py-12 sm:px-6 md:px-10 sm:py-22">
      <div className="flex justify-between items-end gap-4 sm:gap-8 flex-wrap mb-6 sm:mb-12">
        <div className="max-w-[720px]">
          <div
            className="font-mono text-[12px] text-[#71717a] mb-[18px]"
            style={{ letterSpacing: "0.18em" }}
          >
            03 — THE ROADMAP
          </div>
          <h2
            className="font-bold text-white mb-[18px]"
            style={{
              fontSize: "clamp(30px, 3.7vw, 46px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
            }}
          >
            Ten levels from zero to expert
          </h2>
          <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa]">
            One track, taken in order, over about 52 weeks. Each level assumes
            only what the level before it taught you, ends in an online exam
            and earns you a certificate &mdash; and every single level carries
            its own block of AI security topics. Click any level to see what
            is inside it.
          </p>
        </div>
        <div
          className="font-mono text-[11px] text-[#52525b] text-right leading-[1.9]"
          style={{ letterSpacing: "0.1em" }}
        >
          FOUNDATION → CORE → EXPERT
          <br />
          52 WEEKS SELF-PACED · ONLINE EXAM + CERTIFICATE PER LEVEL
        </div>
      </div>

      {/* MOBILE: Accordion */}
      <div className="md:hidden">
        {COURSES.map((co, i) => {
          const isOpen = active === i;
          return (
            <div key={co.lvl} className={`border-b border-[#27272a] ${i === 0 ? "border-t" : ""}`}>
              <button
                type="button"
                onClick={() => setActive(isOpen ? -1 : i)}
                className="flex items-center gap-3 w-full text-left py-4 px-1 cursor-pointer"
              >
                <span
                  className={`w-[28px] h-[28px] flex items-center justify-center rounded-[7px] font-mono text-[12px] font-bold shrink-0 ${
                    isOpen
                      ? "bg-[#a3e635] text-black border border-[#a3e635]"
                      : "bg-transparent text-[#71717a] border border-[#3f3f46]"
                  }`}
                >
                  {co.lvl}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-[15px] font-semibold text-white leading-tight">
                    {co.title}
                  </span>
                </span>
                <span className="font-mono text-[14px] text-[#71717a] shrink-0">
                  {isOpen ? "▾" : "▸"}
                </span>
              </button>
              {isOpen && (
                <div className="px-1 pb-5">
                  <DetailContent co={co} />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* DESKTOP: Two-column layout */}
      <div className="hidden md:grid md:grid-cols-[0.9fr_1.1fr] md:gap-11 items-start">
        <div className="flex flex-col">
          {COURSES.map((co, i) => {
            const on = active === i;
            return (
              <button
                key={co.lvl}
                type="button"
                onClick={() => setActive(i)}
                className={
                  on
                    ? "flex items-center gap-4 w-full text-left bg-[#0f0f11] cursor-pointer font-[inherit] text-white border border-[#3f3f46] border-l-2 border-l-[#a3e635] rounded-r-[10px] px-[22px] py-[18px] -mb-px"
                    : "flex items-center gap-4 w-full text-left bg-transparent cursor-pointer font-[inherit] text-white border border-transparent border-l-2 border-l-[#27272a] rounded-r-none px-[22px] py-[18px] -mb-px hover:bg-[#09090b]"
                }
              >
                <span
                  className={
                    on
                      ? "w-[30px] h-[30px] flex items-center justify-center rounded-[7px] font-mono text-[13px] font-bold bg-[#a3e635] text-black border border-[#a3e635]"
                      : "w-[30px] h-[30px] flex items-center justify-center rounded-[7px] font-mono text-[13px] font-bold bg-transparent text-[#71717a] border border-[#3f3f46]"
                  }
                >
                  {co.lvl}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-[16px] font-semibold tracking-[-0.01em]">
                    {co.title}
                  </span>
                  <span className="block font-mono text-[11px] text-[#71717a] mt-[5px]">
                    {co.weeks} WEEKS · {co.mods} MODULES ·{" "}
                    {co.difficulty.toUpperCase()}
                  </span>
                </span>
                <span
                  className="font-mono text-[10px] tracking-[0.12em] whitespace-nowrap px-2 py-[3px] rounded-[5px]"
                  style={{
                    color: STAGE_COLORS[co.stage].fg,
                    border: `1px solid ${STAGE_COLORS[co.stage].bd}`,
                  }}
                >
                  {co.stage}
                </span>
              </button>
            );
          })}
        </div>

        <div className="md:sticky md:top-[124px] border border-[#27272a] rounded-[14px] bg-[#09090b] p-5 sm:p-[34px]">
          <DetailContent co={current} />
        </div>
      </div>
    </section>
  );
}
